import * as React from 'react';
import PageContainer from "@components/PageContainer";
import classnames from 'classnames';
import PageTitle from "@layout/PageTitle";
import Block from "@layout/Block";
import Font from "@layout/Font";
import { Link } from 'react-router-dom';
import './index.scss';
import { Portfolio } from '@store/index';
import Masonry from 'react-masonry-component';
import { throttle, debounce } from 'throttle-debounce';
import isInViewportPartial from '@utils/ViewPort';

interface OwnProps { 
    portfolios: Portfolio[];
    technologies: string[];
}

interface Props extends OwnProps { }

interface State { 
    animations: number[];
}

class PortfolioPage extends React.Component<Props, State> {
    private ulRef = React.createRef<any>();

    constructor(props: Props) {
        super(props);
        this.state = {
            animations: [],
        }
    }
    componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount() {
        this.removeWindowListeners();
    }

    private removeWindowListeners = () => {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
    }

    private onScroll = throttle(400, () => {
        this.animate();
    })

    private onResize = debounce(1000, () => {
        this.animate();
    })

    private onImagesLoaded = () => this.animate()

    private animate = () => {
        const { animations } = this.state;
        const { portfolios } = this.props;

        if (!this.ulRef.current) {
            return ;
        }
        const lis = Array.from(this.ulRef.current.masonryContainer.children)
            //Skip first item
            .filter((li: HTMLLIElement, index:number) => index > 0) 
            .filter((li: HTMLLIElement, index:number) => 
                -1 === this.state.animations.indexOf(index) &&
                isInViewportPartial(li))
            .map((li: HTMLLIElement, index:number) => +li.id.substr(13))
            .map((index: number) => animations.push(index) && index);

        
        lis && lis.length && this.setState({
            animations
        })
        if (animations.length === portfolios.length) {
            this.removeWindowListeners();
        }
    }

    render(): JSX.Element {
        const { portfolios } = this.props;
        const { animations } = this.state;

        return (
            <PageContainer>
                <Block indent="10">
                    <PageTitle>
                        Welcome to my Portfolio
                    </PageTitle>
                </Block>
                <Block indent="20">
                    <Font font="secondary">
                        Here are my few software development portfolio projects.
                    </Font>
                </Block>
                <Masonry
                    className="portfolio-container"
                    elementType="ul"
                    options={{
                        transitionDuration: 1000,
                        horizontalOrder: true,
                        columnWidth: '.grid-sizer',
                        itemSelector: '.grid-item',
                        percentPosition: true,
                    }}
                    disableImagesLoaded={false} // default false
                    updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
                    onImagesLoaded={this.onImagesLoaded}
                    ref={this.ulRef}
                >
                    <li className="grid-sizer"></li>
                    { 
                        portfolios.map((portfolio, index) => {
                            const animationDelay = Math.floor(Math.random() * 500) + 'ms';
                            const backgroundColor = portfolio.prominentColor;

                            return (
                                <li
                                    className={classnames('grid-item', {animate: animations.indexOf(index) > -1})}
                                    key={`portfolio-${index}`}
                                    id={`portfolio-li-${index}`}
                                >
                                    <div className="grid-item-element">
                                        <Link className="inner-link" to={`/portfolio/${portfolio.slug}`}>
                                            <img src={portfolio.cover.url} style={{animationDelay}} />
                                            <h3 style={{animationDelay}}>{portfolio.name}</h3>
                                            <div className="pre-cover" style={{animationDelay, backgroundColor}}></div>
                                        </Link>
                                        {
                                            portfolio.cover.license &&
                                            <a className="license-link" href={portfolio.cover.license.link}>{portfolio.cover.license.text}</a>
                                        }
                                    </div>
                                </li>
                            )
                        })
                    }
                </Masonry>
            </PageContainer>
        )
    }
    /*
    private inQueryString = (technology: string | string[]): boolean => {
        let tech = this.getTechQueryString();

        return technology.indexOf(tech) > -1;
    }

    private getTechQueryString = (): string => {
        return queryString.parse(this.props.location.search).tech as string;
    }

    private getPorfolioFiltered = (): Portfolio[] => {
        if (!this.getTechQueryString()) {
            return this.props.portfolios;
        }

        return this.props.portfolios.filter((portfolio: Portfolio) => this.inQueryString(portfolio.tech))
    }

    render(): JSX.Element {
        const { technologies } = this.props;

        return (
            <PageContainer>
                <Block indent="15">
                    <div className="portfolio-technologies">
                        {
                            technologies.map((technology: string, index: number) => {
                                const selected = this.inQueryString(technology);

                                return (
                                    <Link
                                        key={`tech-btn-${index}`}
                                        to={(selected) ? '/portfolio?' : `/portfolio?tech=${technology}`}
                                    >
                                        <Button selected={selected}>{technology}</Button>
                                    </Link>
                                )
                            })
                        }
                    </div>
                </Block>
            </PageContainer>
        );
    }
    */
}

export default PortfolioPage;


// WEBPACK FOOTER //
// ./src/components/Portfolio/index.tsx